<template>
<div>
    <button class="gobutton buttonprimary" @click="start()"  >Scheduler </button>

 

     <!-- edit -->
    <actionmodalwide ref="mymodal" > 
        <template v-slot:body>
            <div class="horizFlexStretch">
                <div></div>
                <label class="titlelabel bottom10" v-if="selectedReport!=null && inEdit">Report {{selectedReport.Name}}</label>
                <button class="closebutton buttonprimary" @click="$refs.mymodal.closeModal()" v-if="!isAdd" >Close</button>
            </div>
            <br>
            <div class="maindiv" >
                
                <!-- SELECT SCHED REPORT -->
                 <div v-if="!inEdit" class="borderright pad">
                    <manageitems v-if="!isAdd" ref="schedreplist" :title="title" :itemList="itemList" @add="add()"  @remove="remove" @copy="copy" @edit="edit" @select="select"/>
                    <!-- <reportlookup ref="lookup" v-if="isAdd" @saveandschedule="saveandschedule" @cancel="isAdd=false"/> -->

                    <div>
                        <label v-if="pleaseWait" class="pleasewait">Please Wait...</label>
                    </div>
                    <confirm ref="confirmremove" title="Remove Scheduled Report" body="Do you want to remove the selected scheduled report?" @yes="yesremove"/>
                    
                    
                </div>
                <!-- VIEW ONLY SCHEDULE AND DELIVERY -->
                <div class="viewonly" v-if="!inEdit && selectedReport!=null" >
                      
                     <div class="">
                       <!--  <div class="vertFlexLeft bordered marginright">
                            <div class="">
                                <label class="titlelabel bottom10">Parameters</label>
                            </div>

                        </div> -->
                        <div class="vertFlexLeft bordered marginright">
                            <div class="">
                                <label class="titlelabel bottom10">Schedule</label>
                            </div>

                            <div class="margin10">
                                <label>Run at {{ getTimeName(selectedReport.Schedule.HourOfDay) }}</label>
                            </div>
                            <div class="margin10">
                                <label>{{ getTimeFrameName(timeFrame) }} </label>
                            </div>

                            <div class="margin10">
                                <label>Send {{ getDurationText() }} </label>
                            </div>
                        </div> 
                        
                        <div class="vertFlexLeft bordered">
                            <div class="">
                                <label class="titlelabel bottom10">Email To</label>
                            </div>
                            <div class="vertFlex ">
                                <div v-for="recipient in recipientList" :key="recipient.ID" :value="recipient.ID" class="leftindent">
                                    <div class="horizFlex">
                                        
                                        <label v-if="recipient.selected">
                                            {{recipient.Name}} ({{recipient.EmailAddress}})
                                        </label>
                                        
                                    </div>
                                </div>
            
                            </div>
                        </div>
                        
                     </div>
                </div>
                <!-- ADD=SEL REP. EDIT = PARAMS -->
                <div class="reportlookupandparam borderright" v-show="inEdit">
                   <reportlookup2 ref="lookup"  @saveandschedule="saveandschedule" @cancel="isAdd=false;inEdit=false" :isAdd="isAdd"/>
                </div>
                <!-- EDIT SCHEDULE AND DELIVERY -->
                <div v-if="inEdit && selectedReport!=null">
                    
                    <div class="bordered vertFlexLeft">
                        
                        <!-- <label class="titlelabel bottom10">Report {{selectedReport.Name}}</label> -->
                        
                        <div class="margin10">
                            <label>Name </label>
                            <input class="nameinput" v-model="selectedReport.Name"/>
                        </div>
                    </div>
                    <br>

                    <div class="halves ">
                        <!-- schedule -->
                        <div class="vertFlexLeft bordered marginright ">
                            <div class="">
                                <label class="titlelabel bottom10">Schedule</label>
                            </div>
                            <div class="margin10">
                                <label>Run at </label>
                                <select name="" id="" class='editCombo' v-model="selectedReport.Schedule.HourOfDay" >
                                    <option v-for="time in timeList" :key="time.id" :value="time.id">
                                        {{time.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="margin10">
                                <input type="radio" name="timeradio" value="Daily" v-model="timeFrame" @click="selectDaily()"/> 
                                <label>Daily </label>
                                
                            </div>
                            <div class="margin10">
                                <input type="radio" name="timeradio" value="Weekly" v-model="timeFrame" @click="selectWeekly()"/> 
                                <label>Weekly on </label>
                                <div class="horizFlex">
                                    <div  class="leftindent vertFlex">
                                        <div>
                                            <input type="checkbox" v-model="selectedReport.Schedule.Monday" @click="selectWeekly()"/>
                                            <label>Monday</label> 
                                        </div>
                                            <div>
                                        <input type="checkbox" v-model="selectedReport.Schedule.Tuesday" @click="selectWeekly()"/>
                                        <label>Tuesday</label> 
                                        </div>
                                            <div>
                                        <input type="checkbox" v-model="selectedReport.Schedule.Wednesday" @click="selectWeekly()"/>
                                        <label>Wednesday</label> 
                                        </div>
                                        <div>
                                            <input type="checkbox" v-model="selectedReport.Schedule.Thursday" @click="selectWeekly()"/>
                                            <label>Thursday</label> 
                                        </div>
                                        
                                            
                                        
                                    </div>
                                    <div  class="leftindent vertFlex">
                                        <div>
                                            <input type="checkbox" v-model="selectedReport.Schedule.Friday" @click="selectWeekly()"/>
                                            <label>Friday</label> 
                                        </div>
                                        <div>
                                            <input type="checkbox" v-model="selectedReport.Schedule.Saturday" @click="selectWeekly()"/>
                                            <label>Saturday</label> 
                                        </div>
                                        <div>
                                            <input type="checkbox" v-model="selectedReport.Schedule.Sunday" @click="selectWeekly()"/>
                                            <label>Sunday</label> 
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                            <div class="margin10">
                                <input type="radio" name="timeradio" value="Monthly" v-model="timeFrame" @click="selectMonthly()"/> 
                                <label>Monthly on  </label>
                                
                                    <select name="" id="" class='editCombo' v-model="selectedReport.Schedule.DayOfMonth1" @change="selectMonthly()">
                                        <option v-for="day in dayList" :key="day.id" :value="day.id" >
                                            {{day.name}}
                                        </option>
                                    </select>
                                    
                            
                                <div class="leftindent">
                                    <label> and </label>
                                    <select name="" id="" class='editCombo' v-model="selectedReport.Schedule.DayOfMonth2" @change="selectMonthly()">
                                        <option v-for="day in dayList" :key="day.id" :value="day.id">
                                            {{day.name}}
                                        </option>
                                    </select>
                                </div>
                                
                            </div>
                            <div class="margin10">
                            <hr>
                            </div>
                        
                            <div class="margin10">
                                    <input type="radio" name="durationradio" value="Always" v-model="duration" @click="setAlways()"/> 
                                    <label>Send Always </label>
                            </div>
                            <div class="margin10">
                                    <input type="radio" name="durationradio" value="Dates" v-model="duration" @click="setDates()"/> 
                                    <label>from </label>
                                    <input type="date" class="dateinput" v-model="selectedReport.EffectiveDate" @change="setDates()"/>
                                <div class="leftindent">
                                    
                                    <label> to </label>
                                    <input type="date" class="dateinput"  v-model="selectedReport.ExpirationDate" @change="setDates()"/>
                                </div>
                                    
                            </div>
                        </div>

                        <!-- email -->
                        <div class="vertFlexLeft bordered">
                            <div class="">
                                <label class="titlelabel bottom10">Email To</label>
                            </div>
                            <div class="margin10">
                                <label>Format </label>
                                <input type="radio" name="reporttyperadio" value="1" v-model="selectedReport.Schedule.ReportOutputFormatID"/> 
                                <label>Acrobat </label>
                                <input type="radio" name="reporttyperadio" value="2" v-model="selectedReport.Schedule.ReportOutputFormatID"/> 
                                <label>Excel </label>
                            </div>
                        
                            <div class="margin10">
                                <div class="horizFlex">
                                    <label>Recipients </label>
                                    
                                </div>
                                
                                <div class="vertFlex leftindent">
                                    <div v-for="recipient in recipientList" :key="recipient.ID" :value="recipient.ID">
                                        <div class="horizFlex">
                                            <input type="checkbox" v-model="recipient.selected" @change="selectRecip(recipient)"/>
                                            <label >
                                                {{recipient.Name}} ({{recipient.EmailAddress}})
                                            </label>
                                            <confirm :showImageButton="paramTrue" ref="confirmremoverecip" title="Remove Email Recipient" :body="removereciptext(recipient)" @yes="yesremoverecip(recipient)"/>
                                        </div>
                                    </div>
                                    <addrecipient @refresh="getEmailRecipientList"/>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                    

                    <div class="bordered" v-if="false">
                        <div class="margin10">
                            history
                        </div>
                        
                    </div>
                    <br>
                    <p class="responsemessage">{{ responseMessage }}</p>
                    <div class="rightjustified">
                        <button class="innerbutton buttonhighlight" @click="check">Save</button>
                        <button class="innerbutton buttonprimary" @click="cancel">Cancel</button>
                    </div> 
                        
                    
                </div>
                <confirm ref="confirmsave" title="Save Duplicate Scheduled Report" body="You already have a scheduled report that has the same schedule, parameters and recipients as this one. Do you still want to save this?" @yes="save"/>
            </div>
            
            
           
        </template>
      </actionmodalwide>
      
</div>
  
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import {ReportHTTP} from '../../repository'
import format from '../../format.js'
import lookupviewlayout from '../layouts/lookupviewlayout.vue'
import actionmodalwide from '../controls/actionmodalwide.vue'
import actionmodal from '../controls/actionmodal.vue'
import reportlookup2 from './ReportLookup2.vue'
import lookupresult from '../controls/lookupresult.vue'
import manageitems from './manageitems.vue'
import confirm from '../actions/confirm.vue'
import addrecipient from './addRecipient.vue'
export default {
    name:'reportscheduler2',
    components:{
        actionmodalwide,
        lookupviewlayout,
        reportlookup2,
        actionmodal,
        lookupresult,
        manageitems,
        confirm,
        addrecipient
    },
    mixins:[format],
    props:{
        LocationID:{
            type:Number,
           
        },
        LocationName:{
            type:String,
        }
        
    },
    data(){
        return{
            pleaseWait:false,
            responseMessage:null,
            inEdit:false,
            isAdd:false,
            
            recipientList:[],
            selectedId:0,
            timeFrame:'Daily',
            duration:'Always',
            paramTrue:true,

            timeList:[
                {
                    id:-2,
                    name:""
                },
                {
                    id:-1,
                    name:"At Close"
                },
                {
                    id:0,
                    name:"12 AM"
                },
                {
                    id:1,
                    name:"1 AM"
                },
                {
                    id:2,
                    name:"2 AM"
                },
                {
                    id:3,
                    name:"3 AM"
                },
                {
                    id:4,
                    name:"4 AM"
                },
                {
                    id:5,
                    name:"5 AM"
                },
                {
                    id:6,
                    name:"6 AM"
                },
                {
                    id:7,
                    name:"7 AM"
                },
                {
                    id:8,
                    name:"8 AM"
                },
                {
                    id:9,
                    name:"9 AM"
                },
                {
                    id:10,
                    name:"10 AM"
                },
                {
                    id:11,
                    name:"11 AM"
                },   
                {
                    id:12,
                    name:"12 PM"
                },
                {
                    id:13,
                    name:"1 PM"
                },
                {
                    id:14,
                    name:"2 PM"
                },
                {
                    id:15,
                    name:"3 PM"
                },
                {
                    id:16,
                    name:"4 PM"
                },
                {
                    id:17,
                    name:"5 PM"
                },
                {
                    id:18,
                    name:"6 PM"
                },
                {
                    id:19,
                    name:"7 PM"
                },
                {
                    id:20,
                    name:"8 PM"
                },
                {
                    id:21,
                    name:"9 PM"
                },
                {
                    id:22,
                    name:"10 PM"
                },
                {
                    id:23,
                    name:"11 PM"
                },
            ],
            dayList:[
                {
                    id:0,
                    name:"None"
                },

            ],
            weekdayList:[
                {
                    id:0,
                    name:"Monday"
                },
                {
                    id:1,
                    name:"Tuesday"
                },
                {
                    id:2,
                    name:"Wednesday"
                },
                {
                    id:3,
                    name:"Thursday"
                },
                {
                    id:4,
                    name:"Friday"
                },
                {
                    id:5,
                    name:"Saturday"
                },
                {
                    id:6,
                    name:"Sunday"
                }
            ],
            itemList:[
             
            ],
            newScheduledReport:{
                Name:null,
                EffectiveDate:null,
                ExpirationDate:null,
                Schedule:{
                    Monday:false,
                    Tuesday:false,
                    Wednesday:false,
                    Thursday:false,
                    Friday:false,
                    Saturday:false,
                    Sunday:false,
                    DayOfMonth1:0,
                    DayOfMonth2:0,
                    Daily:true,
                    HourOfDay:0

                },
                RecipientList:[]
            }
        }
    },
    computed:{
        ...mapFields([
      
            'selectedReport',
            'selectedResult'
        ]),
       title(){
        return "Scheduled Reports "
       },
        isAlways(){
            if(this.selectedReport.Schedule.ExpirationDate=='1-01-0001'){
                return true
            }else if(this.selectedReport.ExpirationDate.includes('0001-01-01')){
                return true
            }else{return false}
        },
        

    },
    methods:{
        getTimeName(id){
            return this.getValueName(this.timeList, id)
        },
        getTimeFrameName(timeframe){
            if(timeframe=='Daily'){return 'Daily'}
            else if (timeframe=='Weekly'){
                var str = "Weekly on "
                if(this.selectedReport.Schedule.Monday){str = this.addtoweekstring(str, 'Monday')}
                if(this.selectedReport.Schedule.Tuesday){str = this.addtoweekstring(str, 'Tuesday')}
                if(this.selectedReport.Schedule.Wednesday){str = this.addtoweekstring(str, 'Wednesday')}
                if(this.selectedReport.Schedule.Thursday){str = this.addtoweekstring(str, 'Thursday')}
                if(this.selectedReport.Schedule.Friday){str = this.addtoweekstring(str, 'Friday')}
                if(this.selectedReport.Schedule.Saturday){str = this.addtoweekstring(str, 'Saturday')}
                if(this.selectedReport.Schedule.Sunday){str = this.addtoweekstring(str, 'Sunday')}
                return str
            }
            else if(timeframe=='Monthly'){
                var str = "Monthly on "
                var day1 = this.getValueName(this.dayList, this.selectedReport.Schedule.DayOfMonth1)
                var day2=this.getValueName(this.dayList, this.selectedReport.Schedule.DayOfMonth2)
                str = str + day1 
                if(day1!=null){str = str + ' and ' + day2}
                return str
            }
        },
        addtoweekstring(str,addstr){
            if(str=="Weekly on "){str = str + ' ' + addstr}
            else{str = str + ', ' + addstr}
            return str
        },
        getDurationText(){
            if(this.duration=='Always'){return this.duration}
            else if(this.duration=='Dates'){
                var dt1=this.$options.filters.formatDate(this.selectedReport.EffectiveDate)
                var dt2=this.$options.filters.formatDate(this.selectedReport.ExpirationDate)
                return 'From ' + dt1 + ' to ' + dt2}
        },
        getValueName(valuelist,id){
            var name = null
            valuelist.forEach(myFunction4)
                function myFunction4(item, index2, arr2) {
                    let val=arr2[index2]
                    if(val.id==id){
                        name=val.name
                    }
                }
            return name
        },
        removereciptext(recipient){
           return ' Do you want to remove ' + recipient.Name + '?'
        },
        markRecipients(){
           var recipientList = this.recipientList
            //first clear recip
            recipientList.forEach(myFunction4)
            function myFunction4(item, index2, arr2) {
                let recip2=arr2[index2]
                recip2.selected = false
            }
            this.selectedReport.EmailRecipientList.forEach(myFunction2)
            function myFunction2(item, index, arr) {
                let recip=arr[index]

                recipientList.forEach(myFunction3)
                function myFunction3(item, index2, arr2) {
                    let recip2=arr2[index2]
                    if(recip.EmailAddress==recip2.EmailAddress){
                       // console.log('match')
                        recip2.selected = true
                    }
                }
            }
        },
        selectRecip(selrecip){
            var found=false
            this.selectedReport.EmailRecipientList.forEach(myFunction2)
            
            function myFunction2(item, index, arr) {
                let recip=arr[index]
                if(recip.EmailAddress==selrecip.EmailAddress){
                    recip.selected=!recip.selected
 
                    found=true
                }
            }
            //if we didn't find it, then add it
            if(!found){
          
                this.selectedReport.EmailRecipientList.splice(0,0,selrecip)
            }
        },
        add(){
          //  console.log('add')
            this.isAdd=true
            this.selectedReport=null
            this.inEdit=true
        },
        
        remove(selectedId){
            this.selectedId=selectedId
            this.$refs.confirmremove.Show()
          //  console.log('remove ' + selectedId)
        },
        async yesremove(){
            
            
            let req = {
                scheduledReport:{'ID':this.selectedId}
            }
            this.pleaseWait=true;
            ReportHTTP.post('removescheduledreport',req)
            .then(response=>{
                this.getScheduledReportList()
                this.pleaseWait=false;
               // console.log(response)
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
        },
        
        async yesremoverecip(recip){
            
            
            let req = {
                    emailRecipient:recip
                }
            this.pleaseWait=true;
            ReportHTTP.post('removeemailrecipient',req)
            .then(response=>{
                this.getEmailRecipientList()
                this.pleaseWait=false;
               // console.log(response)
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
        },
        copy(selectedId,name){
            this.selectedId=selectedId
         //   console.log('copy ' + selectedId)
            let req = {
                scheduledReport:{
                    ID:selectedId,
                    Name:name
                }
            }
            this.pleaseWait=true;
            ReportHTTP.post('copyscheduledreport',req)
            .then(response=>{
                this.selectedId=response.data.ResponseInteger
                this.getScheduledReportList()
               // this.inEdit=true
            this.getScheduledReport(this.selectedId)
                this.pleaseWait=false;
                //console.log(response)
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
        },
        edit(selectedId){
            this.selectedId=selectedId
            //console.log('edit ' + selectedId)
            this.inEdit=true
            this.getScheduledReport(selectedId)
        },
        select(selectedId){
            this.selectedId=selectedId
            //console.log('edit ' + selectedId)
            this.getScheduledReport(selectedId)
        },
        hasRecipients(){
            var hasrecip=false
            this.recipientList.forEach(myFunction3)
                function myFunction3(item, index2, arr2) {
                    let recip2=arr2[index2]
                    if(recip2.selected){
                        hasrecip=true
                    }
                }
                return hasrecip
        },
        check(){
            if(!this.hasRecipients()){
                this.responseMessage="Please select at least one recipient"
                return
            }

            let req = {
                scheduledReport:this.selectedReport
            }

            this.pleaseWait=true;
            ReportHTTP.post('checkscheduledreport',req)
            .then(response=>{
                if(response.data.ScheduledReport.ID>0){
                    this.$refs.confirmsave.Show()
                }else{
                    //no match. just save
                    this.save()
                }
                this.pleaseWait=false;
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
        },
        save(){
            if(!this.hasRecipients()){
                this.responseMessage="Please select at least one recipient"
                return
            }

            //get any updated parameters
            if(!this.isAdd){
                this.selectedReport.Parameters=this.selectedResult.Parameters
            }

            let req = {
                scheduledReport:this.selectedReport
            }

            this.pleaseWait=true;
            ReportHTTP.post('savescheduledreport',req)
            .then(response=>{
                this.selectedId=response.data.ScheduledReport.ID
                this.getScheduledReportList()
               // console.log(response.data)
                this.pleaseWait=false;
                this.inEdit=false
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
            this.inEdit=false
        },
        cancel(){
            this.inEdit=false
            this.getScheduledReportList()
        },
        selectItem(){

        },
        start(){
            this.setupDays()
            this.getEmailRecipientList()
            this.getScheduledReportList()
            this.$refs.mymodal.openModal()
        },
        setupDays(){
            for(let i = 1; i<32; i++){
                this.dayList.push({id:i,name:i.toString()})
            }
        },
        saveandschedule(newReportId){
          //  console.log("saved and ready to schedule " + newReportId)
            this.isAdd=false
            this.getScheduledReport(newReportId)
            //this.inEdit=true


           


        },
        async getScheduledReportList(){
            //keep track of the one we had selected
       
             let req = {
                SalonID:-1,
            }
            this.pleaseWait=true;
            ReportHTTP.post('scheduledreportlist',req)
            .then(response=>{
                this.itemList = response.data.ScheduledReportItemList

                //select the one we had if we can
               // console.log("about to select " + this.selectedId)
                this.$nextTick(()=>{
                    this.$refs.schedreplist.selectItemByID(this.selectedId)
                })
                
                this.pleaseWait=false;
               // console.log(response)
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
            
        },
        async getEmailRecipientList(){
             let req = {
                SalonID:0,
            }
            this.pleaseWait=true;
            ReportHTTP.post('emailrecipientlist',req)
            .then(response=>{
                this.recipientList = response.data.EmailRecipientList
                this.markRecipients()
                this.pleaseWait=false;
               // console.log(response)
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
            
        },
        async getScheduledReport(selectedId){
            let req = {
                scheduledReport:{'ID':selectedId}
            }
            this.pleaseWait=true;
            ReportHTTP.post('scheduledreport',req)
            .then(response=>{
                this.selectedReport = response.data.ScheduledReport
                this.selectedReport.EffectiveDate=this.$options.filters.formatDateForInput(this.selectedReport.EffectiveDate)
                
                if(!this.selectedReport.ExpirationDate.includes('0001-01-01')){ 
                    this.duration="Dates"
                    this.selectedReport.ExpirationDate=this.$options.filters.formatDateForInput(this.selectedReport.ExpirationDate)
                }
                else{
                    this.duration='Always'
                    this.selectedReport.ExpirationDate='1-01-0001'
                }
                //console.log(this.selectedReport.ExpirationDate + ' ' + this.duration)
                
                
                if(this.selectedReport.Schedule.Daily){
                    this.selectDaily()
                }else if(this.selectedReport.Schedule.DayOfMonth1!=0){
                    this.selectMonthly()
                }else{
                    this.selectWeekly()
                }
                this.markRecipients()

                //get report
                this.$refs.lookup.getReport(this.selectedReport.ReportID)

                this.pleaseWait=false;
                //this.inEdit=true
                //console.log(response)
            })
            .catch(e=>{
                this.pleaseWait=false;
                if(e.message=='Network Error'){
                    this.errorMessage = "Report Error: Cannot Reach API"
                }
                this.errorMessage = "Report Error: " + e.message;

                console.log(e)
                return e
            });
            
        },
        selectDaily(){
            //clear weekly and monthly
            this.clearWeekly();
            this.clearMonthly();
            this.selectedReport.Schedule.Daily=true
            this.timeFrame="Daily"
        },
        selectWeekly(){
            this.clearMonthly();
            this.selectedReport.Schedule.Daily=false
            this.timeFrame="Weekly"
        },
        selectMonthly(){
            this.clearWeekly();
            this.selectedReport.Schedule.Daily=false
            this.timeFrame="Monthly"
        },
        clearWeekly(){
            this.selectedReport.Schedule.Monday=false
            this.selectedReport.Schedule.Tuesday=false
            this.selectedReport.Schedule.Wednesday=false
            this.selectedReport.Schedule.Thursday=false
            this.selectedReport.Schedule.Friday=false
            this.selectedReport.Schedule.Saturday=false
            this.selectedReport.Schedule.Sunday=false
        },
        clearMonthly(){
            this.selectedReport.Schedule.DayOfMonth1=0
            this.selectedReport.Schedule.DayOfMonth2=0
        },
        setAlways(){
            this.duration="Always"
            this.selectedReport.ExpirationDate='1-01-0001';
        },
        setDates(){
            this.duration="Dates"
        }

    },
    
    mounted(){
        
    }
}
</script>

<style>
:root{

    --text-color:rgb(58, 54, 54)!important;
    --light-text-color:white!important;
}
.maindiv{
    display:grid;
    grid-template-columns: auto auto auto auto;
    width:84vw;
    height:80%;
}
.bordered{
    background-color: white;
    border-radius: 5px;
    padding:10px;
}
.borderright{
    border-right: 1px solid gray;
}
.pad{
    padding:10px;
}
.marginright{
    margin-right:20px;
}
.gobutton{
    
   color:white;
   padding:10px;
   border-radius:10px;
   border:none;
   font-size:inherit;
   margin:10px 0px 0px 10px;
   min-width:130px;
    height:50px;
}
.closebutton{
    
   color:white;
   padding:5px;
   border-radius:10px;
   border:none;
   font-size:inherit;
   margin:10px 10px 10px 10px;
   min-width:70px;
    height:30px;

}
.buttonprimary{
    background-color:var(--primary-color);
}
.buttonhighlight{
    background-color:var(--highlight-color);
}
.innerbutton{
    
   color:white;
   padding:10px;
   border-radius:10px;
   border:none;
   font-size:inherit;
   margin-bottom:20px;
   margin-left:5px;
   width: 75px;
}

.recipbutton{
   background-color:rgb(0,158,192);
   color:white;
   padding:5px;
   border-radius:10px;
   border:none;
   font-size:inherit;
   margin-bottom:10px;
   margin-left:5px;
   width: 70px; 
}
.margin10{
    margin:5px;
}
.vertFlex{
    display:flex;
    flex-direction: column;

}
.leftindent{
    margin-left:20px;
}
.editCombo{
    width:100px;
}
.halves{
    display:grid;
    grid-template-columns: 1fr 1fr;
}
.dateinput{
    width:120px;
    font-style:inherit;
    font-size:inherit;
    margin:5px;
}
.horizFlexStretch{
    width:100%;
    display:flex;
    flex-direction: row;
    justify-content: space-between;
  
}
.nameinput{
    width:400px;
}
input{
    font-style:inherit;
}
.pleasewait{
    color:orangered;
    font-size:x-large;
}
</style>